import React from 'react';
import { Link } from 'react-router-dom';

const NavbarLogo = () => {
  return (
    <Link to="/" className="flex items-center gap-3 group select-none focus:outline-none">
      {/* Contenedor del Icono (Pájaro) */}
      <div className="relative w-8 h-8 sm:w-9 sm:h-9 flex-shrink-0">
        <img 
          src="/images/favico/agora.png" 
          alt="Ágora" 
          className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110 drop-shadow-sm" 
        />
      </div>
      
      {/* Texto de Marca (Oculto en móviles pequeños para limpieza visual) */}
      <span className="font-extrabold text-xl sm:text-2xl tracking-[0.15em] text-agora-gradient hidden sm:block">
        ÁGORA
      </span>
    </Link>
  );
};

export default NavbarLogo;
